import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, of, throwError } from "rxjs";
import { catchError, switchMap } from "rxjs/operators";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { Router } from "@angular/router";

@Injectable()
export class NewAuthHttpInterceptorService implements HttpInterceptor {
    private apiUrlNB = environment.apiNewBackBaseUrl;

    constructor(private route: Router) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // Evita interceptar la petición de autenticación o si la URL es Seguridad/Authenticate
        if (req.headers.has("skipInterceptor") || req.url.includes("Seguridad/Authenticate")) {
            return next.handle(req);
        }

        if (req.url.startsWith(this.apiUrlNB)) {
            return this.getToken().pipe(
                switchMap((token) => {
                    const authRequest = req.clone({
                        setHeaders: { Authorization: `Bearer ${token}` },
                    });
                    return next.handle(authRequest);
                }),
                catchError((err) => {
                    if (err.status === 401 || err.statusText === "Unknown Error") {
                        console.error("Error en el interceptor:", err);
                        console.log("Error en el Interceptor del New Backend");
                        this.route.navigateByUrl("/sesion-expirada");
                    }
                    return throwError(() => err);
                })
            );
        }
        return next.handle(req);
    }

    getToken() {
        const token = JSON.parse(sessionStorage.getItem("TokenNewBack"));
        return of(token); // Convierte el token en un Observable
    }
}
